<template>
  <!-- =========== 报价详情 =========== -->
  <div class="QuoteDetail">
    <div class="QuoteDetail_title">
      <span>{{offerDetails.bjname}}</span>
    </div>
    <el-tabs v-model="activeName"
             style="width:90%">
      <el-tab-pane label="报价详情"
                   name="0">
        <div class="QuoteDetail_info">
          <div class="info_item">
            预估时效：<span>{{offerDetails.sxday}}天</span>
          </div>
          <div class="info_item">
            是否包税：<span>{{offerDetails.tax}}</span>
          </div>
          <div class="info_item">
            出口报关：<span>{{offerDetails.iscdf==1?'支持':'不支持'}}</span>
          </div>
          <div class="info_item">
            报关费：<span>￥{{offerDetails.cdf}}</span>
          </div>
          <div class="info_item">
            材积系数：<span>{{offerDetails.cjxs}}</span>
          </div>
          <div class="info_item"
               v-if='offerDetails.paobfb!=100'>
            材积分泡：<span>{{offerDetails.paobfb}}%</span>
          </div>
        </div>

        <div class="QuoteDetail_goodsType">
          <div class="view_title"><span>物品类型：</span></div>
          <el-table :data="offerDetails.wptype"
                    border
                    :header-cell-style="{'text-align':'center'}"
                    :cell-style="{'text-align':'center'}"
                    style="width: 100%">
            <el-table-column prop="wpname"
                             label="类别"
                             width="180">
            </el-table-column>
            <el-table-column prop="info"
                             label="品名">
            </el-table-column>
            <el-table-column prop="price"
                             label="附加费"
                             width="180">
            </el-table-column>
          </el-table>
        </div>

        <div class="zipQjpice">
          <div class="view_title"><span>区间价：</span></div>
          <t-table :data='trTbale'
                   v-if="zipPriceTableShow"
                   :thData='thTbale'>

          </t-table>
        </div>

        <div class="QuoteDetail_goodsType"
             v-if="offerDetails.zipcode&&!zipPriceTableShow">
          <div class="view_title"><span>邮编区间价：</span></div>
          <el-table :data="offerDetails.zipcode"
                    border
                    :header-cell-style="{'text-align':'center'}"
                    :cell-style="{'text-align':'center'}"
                    style="width: 100%">
            <el-table-column prop="zipcode"
                             label="邮政编码">
            </el-table-column>

            <el-table-column prop="price"
                             label="附加费">
            </el-table-column>
          </el-table>
        </div>

        <div class="QuoteDetail_goodsType"
             v-if="offerDetails.qjprice&&!zipPriceTableShow">
          <div class="view_title"><span>区间价：</span></div>
          <el-table :data="offerDetails.qjprice"
                    border
                    :header-cell-style="{'text-align':'center'}"
                    :cell-style="{'text-align':'center'}"
                    style="width: 100%">
            <el-table-column prop="min"
                             label="最小区间">
            </el-table-column>
            <el-table-column prop="max"
                             label="最大区间">
            </el-table-column>
            <el-table-column prop="xzdw"
                             label="续重单位（ KG ）">
            </el-table-column>
            <el-table-column prop="price"
                             label="附加费">
            </el-table-column>
          </el-table>
        </div>

        <div class="QuoteDetail_goodsType"
             v-if="offerDetails.city">
          <div class="view_title"><span>城市区间价：</span></div>
          <el-table :data="offerDetails.city"
                    border
                    :header-cell-style="{'text-align':'center'}"
                    :cell-style="{'text-align':'center'}"
                    style="width: 100%">
            <el-table-column prop="city"
                             label="城市">
            </el-table-column>
            <el-table-column prop="price"
                             label="附加费">
            </el-table-column>
          </el-table>
        </div>

        <div class="QuoteDetail_goodsType"
             v-if="offerDetails.province">
          <div class="view_title"><span>省份区间价：</span></div>

          <el-table :data="offerDetails.province"
                    border
                    :header-cell-style="{'text-align':'center'}"
                    :cell-style="{'text-align':'center'}"
                    style="width: 100%">

            <el-table-column prop="province"
                             label="省份">
            </el-table-column>

            <el-table-column prop="price"
                             label="附加费">
            </el-table-column>

          </el-table>

        </div>

        <div class="QuoteDetail_goodsType"
             v-if="offerDetails.fbainfo">
          <div class="view_title"><span>FBA区间价：</span></div>
          <el-table :data="common.transform(offerDetails.fbainfo) "
                    border
                    :header-cell-style="{'text-align':'center'}"
                    :cell-style="{'text-align':'center'}"
                    style="width: 100%">
            <el-table-column prop="fbacode"
                             label="仓库代码">
            </el-table-column>
            <el-table-column prop="price"
                             label="附加费">
            </el-table-column>
          </el-table>
        </div>

      </el-tab-pane>
      <el-tab-pane label="包裹限制"
                   name="1">
        <div class="parcel_astrict">
          <div class="view_title"><span>包裹限制：</span></div>
          <div class="astrict_view"
               v-html="offerDetails.xzinfo"></div>
        </div>
      </el-tab-pane>
      <el-tab-pane label="渠道详情"
                   name="2">
        <div class="parcel_astrict">
          <div class="view_title"><span>渠道详情：</span></div>
          <div class="astrict_view"
               v-html="offerDetails.info"></div>
        </div>
      </el-tab-pane>
      <el-tab-pane label="温馨提示"
                   name="3">
        <div class="parcel_astrict">
          <div class="view_title"><span>渠道详情：</span></div>
          <div class="astrict_view"
               v-html="offerDetails.oneinfo"></div>
        </div>
      </el-tab-pane>
      <el-tab-pane label="赔偿责任"
                   name="4">
        <div class="parcel_astrict">
          <div class="view_title"><span>赔偿责任：</span></div>
          <div class="astrict_view"
               v-html="offerDetails.twoinfo"></div>
        </div>
      </el-tab-pane>

    </el-tabs>
  </div>
</template>

<script>
import { apiOffer } from '@/request/api'
import tTable from '@/components/tTable.vue'
import common from '@/assets/js/common'
export default {
  data () {
    return {
      common,
      activeName: '0',
      //  -----------报价详情-----------
      offerDetails: {},
      zipPriceTableShow: false,
      // 二维表格数据
      thTbale: [],
      trTbale: [],
    }
  },
  methods: {
    // 邮编和区间价数据格式化
    zipcodeData () {
      this.zipPriceTableShow = true;
      this.thTbale = ['分区'];
      let test = {}

      for (const key in this.offerDetails.zipcode) {
        if (!test[this.offerDetails.zipcode[key].price]) {
          test[this.offerDetails.zipcode[key].price] = []
        }
        test[this.offerDetails.zipcode[key].price].push(this.offerDetails.zipcode[key].zipcode)
      }

      for (const key in test) {
        let price = []
        let qjp = []
        for (const k in this.offerDetails.qjprice) {
          price.push(parseFloat(this.offerDetails.qjprice[k].price) + parseFloat(key))
          qjp.push(this.offerDetails.qjprice[k].price)
        }

        this.trTbale.push({
          label: test[key].join(','),
          value: price,
        })
      }

      for (const key in this.offerDetails.qjprice) {
        if (this.offerDetails.qjprice.length - 1 == key) {
          this.thTbale.push(this.offerDetails.qjprice[key].min + '+')
          continue
        }
        this.thTbale.push(this.offerDetails.qjprice[key].min + '-' + this.offerDetails.qjprice[key].max)
      }
    },
    //  -----------获取报价详情-----------
    async getOfferDetails () {
      let res = await apiOffer({
        bjid: this.$route.query.id,
        weight: 1
      })

      if (res.errno == 0) {
        this.offerDetails = res.allbj[0]
        this.offerDetails.wptype = common.transform(this.offerDetails.wptype)
        this.offerDetails.zipcode = common.transform(this.offerDetails.zipcode)
        if (res.allbj[0].zipcode && res.allbj[0].qjprice) {
          this.zipcodeData()
        }
      } else {
        this.$message.error(res.message)
      }

    }
  },
  components: {
    tTable
  },
  computed: {

  },
  created () {
    //  -----------判断是否带有ID-----------
    if (!this.$route.query.id) {
      this.$message({
        message: '您还未选择报价方案',
        type: 'error',
        onClose: () => {
          this.$router.go(-1)
        }
      })
    } else {
      this.getOfferDetails()
    }
  }
}
</script>

<style lang='scss'>
.QuoteDetail {
  padding: 20px 0;
  width: 100%;
  height: 100%;
  overflow: auto;
  background-color: #fff;
  color: #333;
  display: flex;
  align-items: center;
  box-sizing: border-box;
  flex-direction: column;
  .el-tab-pane {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
  .el-tabs__nav-scroll {
    display: flex;
    justify-content: center;
    .is-active {
      color: #4c90fd !important;
    }
    .el-tabs__item {
      font-size: 20px;
      color: #666;
    }
  }
  .view_title {
    margin-bottom: 30px;
    font-size: 20px;
    font-weight: 700;
    color: #333;
  }
  .QuoteDetail_title {
    width: 100%;
    min-height: 80px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 30px;
    letter-spacing: 2px;
    font-weight: 700;
    // background-color: pink;
  }
  .zipQjpice {
    margin-top: 20px;
    width: 100%;
    table {
      border-color: #999;
      font-size: 16px;
      th,
      td {
        color: #666;
        padding: 10px 0;
      }
    }
  }
  .QuoteDetail_areaPrice,
  .QuoteDetail_goodsType,
  .parcel_astrict {
    width: 100%;
    margin-top: 30px;
  }
  .parcel_astrict {
    .astrict_view {
      width: 100%;
      background-color: #eee;
      padding: 10px;
      border-radius: 4px;
    }
  }

  .QuoteDetail_info {
    color: #666;
    width: 90%;
    min-height: 100px;
    // background-color: pink;
    display: flex;
    align-items: center;
    justify-content: space-between;
    .info_item {
      font-weight: 700;
    }
    span {
      color: #409eff;
      font-weight: normal;
    }
  }
}
</style>
